//============================================================================
// Name        : ls_download.ts
// Purpose     : Implement handling LS data download
// Created     : 2020-12-27
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

import axios from "axios";
import { IChannelData, LsSyncBase } from "./ls_sync_base";

declare const lsDownloadUrl: string;
// declare const lsCheckAccessUrl: string;

export class LsDownload extends LsSyncBase {
    constructor() {
        super("downloadDialog");
    }

    show(): void {
        this.connectLScable(this.dialogId, (data: IChannelData) => {
            console.log(data);
            // const successLsCredentials  = "LS credentials are fine";
            // const errorLsCredentials    = "LS credentials has some problems";

            // if (data.message == successLsCredentials || data.message == errorLsCredentials) {
            //     if (data.inProgress && data.success) {
            //         $(".checkLSAccessStatus").hide();
            //         LsDownload.UpdateCheckLSAccessStatus(this.dialogId, data.message, data.inProgress, data.success);
            //         this.syncStartToContinue();
            //     } else if (!data.inProgress && !data.success) {
            //         LsDownload.UpdateCheckLSAccessStatus(this.dialogId, data.message, data.inProgress, data.success);
            //         $("#syncLsCredentialsDialog").modal("show");
            //     }
            // } else
            if (!data.inProgress) {
                LsDownload.UpdateCurrentStatus(this.dialogId, data.message, data.inProgress, data.success);
                this.disconnect();
                if (data.success) {
                    $(".continue-actions").show();
                    $(".download_statusTitle").hide();
                    this.showRefreshBtn();
                }
            } else {
                LsDownload.UpdateCurrentStatus(this.dialogId, data.message, data.inProgress, data.success);
            }
        });

        // this.downloadDialogCheckLsAccessButton.off("click");
        // this.downloadDialogCheckLsAccessButton.on("click", () => { this.checkLSAccess(); });
        this.downloadDialogContinueButton.off("click");
        this.downloadDialogContinueButton.on("click", () => { this.doDownload(); });
        this.downloadDialogContinueButton.show();
        $(".currentStatus").hide();
        $(".continue-actions").hide();
        // $(".checkLSAccessStatus").hide();
        $("#downloadDialog").modal("show");
    }

    async doDownload() {
        this.downloadDialogContinueButton.hide();
        $(".currentStatus").show();

        const resp = await axios.get(lsDownloadUrl);
        if (resp.status != 200) {
            window.showErrorDialog("Generating synchronization preview.");
            return;
        }
    }

    // syncStartToContinue() {
    //     $(".checkLSAccessStatus").delay(5000).fadeOut("slow");
    //     $(".continue-actions").show();
    //     setTimeout(() => { this.downloadDialogContinueButton.click(); }, 100);
    // }

    // async checkLSAccess() {
    //     this.downloadDialogCheckLsAccessButton.hide();
    //     $(".checkLSAccessStatus").show();
    //
    //     const resp = await axios.get(lsCheckAccessUrl);
    //     if (resp.status != 200) {
    //         window.showErrorDialog("something went wrong, try again later.");
    //         return;
    //     }
    // }
}
